module.exports = __webpack_public_path__ + "static/media/terminal_selection_origin_title_icon.4a0dc6a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/pickMeUp/images/terminal_selection_origin_title_icon.svg
// module id = 542
// module chunks = 0